var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc20TrendingDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "m3.613 5.21.094.083L8 9.585l2.293-2.292a1 1 0 0 1 1.32-.083l.094.083L15 10.585l1.293-1.292c.602-.603 1.614-.22 1.701.593L18 10v4a1 1 0 0 1-.883.993L17 15h-4c-.852 0-1.297-.986-.783-1.623l.076-.084L13.585 12 11 9.415l-2.293 2.292a1 1 0 0 1-1.32.083l-.094-.083-5-5a1 1 0 0 1 1.32-1.497Z"
})));
export default SvgIc20TrendingDown;